// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-container {
    display: flex;
    width: 100%;
    gap: 10px; /* Space between input and button */
    margin-bottom: 20px; /* Space below input-container */
}

.checkpoint-input {
    flex: 1 1; /* Input takes up remaining space */
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.checkpoint-button {
    padding: 10px 20px;
    font-size: 16px;
    border: none;
    background-color: #007bff;
    color: white;
    border-radius: 4px;
    cursor: pointer;
}

.checkpoint-button:hover {
    background-color: #0056b3;
}

.checkpoint-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.checkpoint-table th,
.checkpoint-table td {
    border: 1px solid #ccc;
    padding: 10px;
    text-align: left;
}

.checkpoint-table th {
    background-color: #f5f5f5;
}

.checkpoint-table .timestamp-column {
    width: 150px; /* Fixed width for timestamp column */
}

.checkpoint-table .action-column {
    width: 90px; /* Fixed width for action column */
}

.checkout-button {
    padding: 5px 10px;
    background-color: #28a745;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    margin-left: 10px; /* Margin between description and button */
}

.checkout-button:hover {
    background-color: #218838;
}
`, "",{"version":3,"sources":["webpack://./src/components/codegen/CheckpointManager.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,WAAW;IACX,SAAS,EAAE,mCAAmC;IAC9C,mBAAmB,EAAE,gCAAgC;AACzD;;AAEA;IACI,SAAO,EAAE,mCAAmC;IAC5C,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY,EAAE,qCAAqC;AACvD;;AAEA;IACI,WAAW,EAAE,kCAAkC;AACnD;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB,EAAE,0CAA0C;AACjE;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".input-container {\r\n    display: flex;\r\n    width: 100%;\r\n    gap: 10px; /* Space between input and button */\r\n    margin-bottom: 20px; /* Space below input-container */\r\n}\r\n\r\n.checkpoint-input {\r\n    flex: 1; /* Input takes up remaining space */\r\n    padding: 10px;\r\n    font-size: 16px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n}\r\n\r\n.checkpoint-button {\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    border: none;\r\n    background-color: #007bff;\r\n    color: white;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n}\r\n\r\n.checkpoint-button:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n.checkpoint-table {\r\n    width: 100%;\r\n    border-collapse: collapse;\r\n    margin-top: 20px;\r\n}\r\n\r\n.checkpoint-table th,\r\n.checkpoint-table td {\r\n    border: 1px solid #ccc;\r\n    padding: 10px;\r\n    text-align: left;\r\n}\r\n\r\n.checkpoint-table th {\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n.checkpoint-table .timestamp-column {\r\n    width: 150px; /* Fixed width for timestamp column */\r\n}\r\n\r\n.checkpoint-table .action-column {\r\n    width: 90px; /* Fixed width for action column */\r\n}\r\n\r\n.checkout-button {\r\n    padding: 5px 10px;\r\n    background-color: #28a745;\r\n    color: white;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    margin-left: 10px; /* Margin between description and button */\r\n}\r\n\r\n.checkout-button:hover {\r\n    background-color: #218838;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
